import type { Unterschrift } from '@wertermittlung/shared';
import { el } from '../../lib/dom.js';
import type { WizardCtx } from './types.js';

/** Unterschriften-Pad (Pointer Events, Touch & Maus). */
export function sigPad(ctx: WizardCtx, s: Unterschrift): HTMLElement {
  const box = el('div', { style: 'margin-bottom:18px' });
  box.append(el('div', { style: 'font-size:13px;font-weight:700;margin-bottom:6px' }, s.rolle));

  const canvas = el('canvas', {
    class: 'sigpad',
    width: '640',
    height: '200',
    'aria-label': `Unterschriftsfeld ${s.rolle}`,
  });
  box.append(canvas);

  const ctx2d = canvas.getContext('2d');
  if (ctx2d) {
    ctx2d.lineWidth = 2.4;
    ctx2d.lineCap = 'round';
    ctx2d.lineJoin = 'round';
    ctx2d.strokeStyle = getComputedStyle(document.body).color;
    if (s.img) {
      const im = new Image();
      im.onload = () => ctx2d.drawImage(im, 0, 0, canvas.width, canvas.height);
      im.src = s.img;
    }
    let drawing = false;
    let last = { x: 0, y: 0 };
    const pos = (e: PointerEvent) => {
      const r = canvas.getBoundingClientRect();
      return {
        x: ((e.clientX - r.left) * canvas.width) / r.width,
        y: ((e.clientY - r.top) * canvas.height) / r.height,
      };
    };
    canvas.addEventListener('pointerdown', (e) => {
      if (ctx.p.readonly) return;
      drawing = true;
      last = pos(e);
      canvas.setPointerCapture(e.pointerId);
    });
    canvas.addEventListener('pointermove', (e) => {
      if (!drawing) return;
      const p = pos(e);
      ctx2d.beginPath();
      ctx2d.moveTo(last.x, last.y);
      ctx2d.lineTo(p.x, p.y);
      ctx2d.stroke();
      last = p;
    });
    const end = () => {
      if (!drawing) return;
      drawing = false;
      s.img = canvas.toDataURL('image/png');
      ctx.save();
      ctx.recalc();
    };
    canvas.addEventListener('pointerup', end);
    canvas.addEventListener('pointercancel', end);
  }

  const meta = el('div', { class: 'sigmeta' });
  const name = el('input', { type: 'text', placeholder: 'Name, Vorname' });
  name.value = s.name;
  name.addEventListener('input', () => {
    s.name = name.value;
    ctx.save();
  });
  const clearBtn = el('button', { class: 'btn-ghost', type: 'button' }, 'Löschen');
  clearBtn.addEventListener('click', () => {
    ctx2d?.clearRect(0, 0, canvas.width, canvas.height);
    s.img = null;
    ctx.save();
    ctx.recalc();
  });
  meta.append(name, clearBtn);
  box.append(meta);
  return box;
}
